import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { TablePagination, IconButton } from "@mui/material";

type PaginationProps = {
  payloadSize: number;
  currentPage: number;
  totalCount: number;
  lastEvaluatedKey?: null;
  handleChangeRowsPerPage: any;
  handleChangePage: any;
};

const Pagination: React.FC<PaginationProps> = ({
  payloadSize,
  currentPage,
  totalCount,
  lastEvaluatedKey,
  handleChangeRowsPerPage,
  handleChangePage
}) => {
  const theme = useTheme();
  const useStyles = makeStyles(() =>
    createStyles({
      root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5)
      }
    })
  );

  function TablePaginationActions() {
    const styleClasses = useStyles();

    // Calculate if there are more pages
    const hasMorePages = (currentPage + 1) * payloadSize < totalCount;

    const handleBackButtonClick = (
      event: React.MouseEvent<HTMLButtonElement> | null
    ) => {
      handleChangePage(event, currentPage - 1);
    };

    const handleNextButtonClick = (
      event: React.MouseEvent<HTMLButtonElement> | null
    ) => {
      handleChangePage(event, currentPage + 1);
    };

    return (
      <div className={styleClasses.root}>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={currentPage === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={!hasMorePages}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
      </div>
    );
  }

  return (
    <React.Fragment>
      <TablePagination
        component="div"
        rowsPerPageOptions={[10, 50, 100]}
        colSpan={3}
        count={totalCount}
        rowsPerPage={payloadSize}
        page={currentPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationActions}
      />
    </React.Fragment>
  );
};

export default Pagination;
